<template>
    <RegularModal ref="modal">
        <template v-slot:title>{{ translate("admin_share_fights_queue.title") }}</template>
        <template v-slot:body>
            <div v-if="store.sharePublicFightsQueue !== null">
                <p class="mb-4">{{ translate("admin_share_fights_queue.info") }}</p>

                <p class="mb-4">
                    <span class="has-text-grey-light mr-2">{{ translate("admin_share_brackets.current_status") }} </span>
                    <span class="tag" :class="store.sharePublicFightsQueue ? 'is-success' : 'is-danger'">
                        {{ store.sharePublicFightsQueue ? translate("common.enabled") : translate("common.disabled") }}
                    </span>
                </p>

                <div v-if="store.sharePublicFightsQueue">
                    <p class="has-text-grey-light">{{ translate("admin_share_brackets.address") }}</p>
                    <a :href="publicUrl" target="_blank" rel="noopener">{{ publicUrl }}</a>
                    <p class="help mt-4">{{ translate("admin_share_fights_queue.hint") }}</p>
                </div>
            </div>
        </template>
        <template v-slot:footer>
            <div class="buttons">
                <button class="button" @click="close">{{ translate("common.close") }}</button>
                <LoadingButton
                    v-if="store.sharePublicFightsQueue !== null"
                    :is-loading="saving"
                    class="button"
                    :class="store.sharePublicFightsQueue ? 'is-danger' : 'is-success'"
                    @click="toggleSharing"
                >
                    <span class="icon">
                        <i class="fas" :class="store.sharePublicFightsQueue ? 'fa-times' : 'fa-share-square'"></i>
                    </span>
                    <span>
                        {{
                            store.sharePublicFightsQueue
                                ? translate("admin_share_fights_queue.disable")
                                : translate("admin_share_fights_queue.title")
                        }}
                    </span>
                </LoadingButton>
            </div>
        </template>
    </RegularModal>
</template>

<script setup lang="ts">
    import { computed, ref } from "vue";
    import RegularModal from "../Common/RegularModal.vue";
    import LoadingButton from "../Common/LoadingButton.vue";
    import { translate } from "../Common/translations";
    import { handleError } from "../Common/errorHandler";
    import { successToast } from "../Common/toasts";
    import { useModal } from "../Common/useModal";
    import urls from "../Urls/urls";
    import { useSchedulesListingStore } from "./useSchedulesListingStore";

    const props = defineProps<{
        eventSlug: string;
    }>();

    const store = useSchedulesListingStore();
    const saving = ref(false);

    const { modal, open, close } = useModal();

    const publicUrl = computed(() => {
        const path = urls.publicEventPages(store.eventId, props.eventSlug).currentMatchesUrl();

        return window.location.origin + path;
    });

    function toggleSharing() {
        const enable = !store.sharePublicFightsQueue;
        saving.value = true;
        store
            .updateFightsQueueSharing(enable)
            .then(() => {
                successToast(translate(enable ? "admin_share_fights_queue.enabled_toast" : "admin_share_fights_queue.disabled_toast"));
            })
            .catch(handleError)
            .finally(() => {
                saving.value = false;
            });
    }

    defineExpose({ open });
</script>
